"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatItemSchemaPriceToNumber = exports.formatItemSchemaPriceToString = void 0;
function formatItemSchemaPriceToString(price) {
    if (!price)
        return null;
    const trimmedPrice = price.trim();
    if (trimmedPrice === '')
        return null;
    return formatPrice(trimmedPrice).toFixed(2);
}
exports.formatItemSchemaPriceToString = formatItemSchemaPriceToString;
function formatItemSchemaPriceToNumber(price) {
    if (!price)
        return null;
    const trimmedPrice = price.trim();
    if (trimmedPrice === '')
        return null;
    return formatPrice(trimmedPrice);
}
exports.formatItemSchemaPriceToNumber = formatItemSchemaPriceToNumber;
function formatPrice(trimmedPrice) {
    return Number(trimmedPrice.replace(/(^\$)|,/g, ''));
}
//# sourceMappingURL=price-formatter.js.map